import React from 'react'
import { cn } from '@/lib/utils'
import { StreamingReasoningText } from './StreamingReasoningText'
import type { AgentChatTimelineItem } from './agentChatUtils'
import { AgentChatToolFallback } from './AgentChatToolFallback'

const activityTextClassName = 'text-sm text-muted-foreground'

type AgentTurnTimelineProps = {
    timeline: AgentChatTimelineItem[]
    onProgress?: () => void
}

export const AgentTurnTimeline: React.FC<AgentTurnTimelineProps> = ({
    timeline,
    onProgress,
}) => {
    if (timeline.length === 0) {
        return null
    }

    return (
        <ol className="my-0 flex list-none flex-col gap-2">
            {timeline.map((item) => {
                if (item.type === 'reasoning') {
                    return (
                        <li key={item.id}>
                            <StreamingReasoningText
                                segmentId={item.id}
                                content={item.content}
                                enabled={false}
                                className={cn(
                                    activityTextClassName,
                                    'whitespace-pre-wrap leading-relaxed',
                                )}
                                onProgress={onProgress}
                            />
                        </li>
                    )
                }

                return (
                    <AgentChatToolFallback
                        key={item.id}
                        toolName={item.toolName}
                    />
                )
            })}
        </ol>
    )
}
